import React, { useEffect } from 'react'
import CatergoryGrid from './store/store-category-grid'
import { useProjectName } from '../../Context/ProjectNameContext';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { getToken } from '../../utils/auth';

function Index() {
  const projectName = useProjectName();
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng); // Change language dynamically
  };
    const handleVisitCount = async () => {
    try {
        const token = getToken();
        const response = await axios.post(
            `${process.env.REACT_APP_URL}/api/stats/module`,
            {
                moduleType: "qrcHero"
            }, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        }
        );
        
    } catch (error) {
        console.error('Failed Visit count', error);
    }

}
useEffect(()=>{
    handleVisitCount();
},[])
  return (
    <div id="content-page" className="content-page position-relative ">
      <div className="text-primary" style={{ fontWeight: "bold", fontSize: "20px", display: "flex", justifyContent: "center" }}>
        {t('create_a')} {projectName} {t('qrc')}
       
      </div>
      <CatergoryGrid />
    </div>
  )
}

export default Index


